export enum BillableEventStatusEnum {
	PENDING = 'pending',
	LEASED = 'leased',
	DISPATCHED = 'dispatched',
	FAILED = 'failed',
}
